/**
 *
 * Compare 2 objects, but only at a single level.
 *
 * This is a 'cheat' for comparison since we store all values+errors
 * in a flat object like:
 *
 * {
 *     "field1": "hello",
 *     "field2.thats.nested": "flatObjectCompare",
 * }
 *
 *
 * @param left
 * @param right
 */
export function flatObjectCompare<T extends { [index: string]: any }>(left: T, right: T): boolean {
    const akeys = Object.keys(left);
    const bkeys = Object.keys(right);

    /**
     * If key lengths differ, they are 100% not equal
     */
    if (akeys.length !== bkeys.length) return false;

    /**
     * Check every A key against every B key
     */
    return akeys.every((akey) => right[akey] === left[akey]);
}
